import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import {
  setAllFiles,
  setShowFileUploader,
} from "../../redux/admin/fileManagerSlice";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const viewAllFiles = (
  dispatch,
  Page,
  Limit,
  setPagination,
  allFiles,
) => {
  axiosInstance
    .get(`/file/all-files/?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      const newFiles = res.data.files;

      const merged = Page === 1 ? newFiles : [...allFiles, ...newFiles];

      dispatch(setAllFiles(merged));

      setPagination(res.data.pagination);
    })
    .catch((err) => {
      console.log("error");
    });
};

export const uploadFIles = (formData, dispatch) => {
  axiosInstance
    .post(`/file/upload`, formData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      if (res.data.message === "Files uploaded successfully") {
        toast.success("Files uploaded");
      }
      dispatch(setShowFileUploader(false));
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const deleteFiles = (
  multiSelected,
  dispatch,
  Page,
  Limit,
  setPagination,
  allFiles,
) => {
  const allIds = multiSelected.map((item) => item.id);
  axiosInstance
    .post(
      `/file/delete-files`,
      { ids: allIds },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      if (res.data.message === "Files deleted successfully") {
        toast.success("Files deleted");
        viewAllFiles(dispatch, Page, Limit, setPagination, allFiles);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
